import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  AWS_IMAGE_FOLDER_BRANDS,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { checkUserPermission } from "../../../../common/UserPermission";

//--------Material React Table------//
import { Box, Button } from "@mui/material";
import { Noimage } from "../../../../common/imagePath";
import { uploadAWS } from "../../../../common/AWSHelper";
import InventorySubModulesRecordsModal from "../../../../components/Modal/InventorySubModulesRecordsModal";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "add-brand";
let PERMISSION_EDIT = "edit-brand";
let PERMISSION_DELETE = "delete-brand";

const Brand = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const [selectedImage, setSelectedImage] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    Imagename: "",
    brandInfopopup: "",
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(4);
  const [runApi, setRunApi] = useState(false);
  const [brandName, setBrandName] = useState("");
  const [moduleID, setModuleId] = useState(0);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [checkedBox, setCheckedBox] = useState([]);
  const [valueAllChecked, setValueAllChecked] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [modal, setModal] = useState(false);
  const [enableFirstSite, setEnableFirstSite] = useState(false);

  //table state
  const [filtertext, setFiltertext] = useState("");
  const [sorting, setSorting] = useState([{ id: "Name", desc: false }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [showLoaderUploadImage, setShowLoaderUploadImage] = useState(false);
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [firstDynamicAlies, setFirstDynamicAlies] = useState();
  const [secondDynamicAlies, setSecondDynamicAlies] = useState();
  const [thirdDynamicAlies, setThirdDynamicAlies] = useState();

  const [firstDynamicVisble, setFirstDynamicVisible] = useState(false);
  const [secondDynamicVisble, setSecondDynamicVisible] = useState(false);
  const [thirdDynamicVisble, setThirdDynamicVisible] = useState(false);

  const [dynamicSiteRespose, setDynamicSiteRespose] = useState([]); // your main data source

  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmActionIsEcom, setconfirmActionIsEcom] = useState(null);

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Brand name is required"),
  });
  // console.log(rowSelection, "sorting=>1");
  // console.log(rowSelectData, "sorting=>2");
  // console.log(
  //   data.length > 0 ? data.map((el) => el?.MainSite) : "",
  //   "check this for updated check box"
  // );
  // console.log(
  //   data.every((item) => item.MainSite == 1),
  //   "check this for updated check box12"
  // );

  let parentbrandoption = [];
  const itemkits = data.map((u, i) => {
    parentbrandoption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  // Get all Brand data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder1,
    pagination,
    currentorder
  ) => {
    setLoading(true);

    const columnIndex =
      sorting.length > 0 ? (sorting ? sorting[0]?.id : "") : "";

    axios
      .get(
        `${config.brandBaseUrl}/brands?filtertext=${
          filtertext == undefined ? "" : filtertext
        }&currentorder=${
          currentorder?.length > 0
            ? currentorder[0]?.desc === undefined
              ? "desc"
              : currentorder[0]?.desc === true
              ? "desc"
              : "asc"
            : "desc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination?.pageIndex + 1
        }&pagesize=${0}&from=0`, //pagination?.pageSize
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setLoading(false);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        const updatedData = res.data.ResponseData?.filter(
          (el) => el.IsShowEcommerceMenu === 1
        );
        const idArray = updatedData.map((el) => el.ID);
        setCheckedBox(idArray);

        if (res.data.ResponseData?.length === idArray?.length) {
          setValueAllChecked(true);
        } else {
          setValueAllChecked(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    setLoading(false);
  };

  useEffect(() => {
    handleListData(
      1,
      perPage,
      filtertext,
      sortingId,
      sortingDirection,
      pagination,
      sorting
    );
  }, [filtertext, sortingId, sortingDirection, pagination, sorting]);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.brandBaseUrl}/brands/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const brandData = res.data.ResponseData[0];
        console.log(brandData, "checkedit=>");

        const data = {
          ID: brandData.ID,
          Name: brandData.Name,
          Imagename: brandData.Imagename,
          brandInfopopup: brandData.brandInfopopup,
        };
        setFormValues(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const uploadFile = async (file, type, event) => {
    setShowLoaderUploadImage(true);
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_BRANDS, (data) => {
      if (data) {
        console.log(data, "data=>");
        setImageUrl(data);
        setShowLoaderUploadImage(false);
        handleSubmit(data, event);
      } else {
        console.log(data, "data error=>");
      }
    });
  };

  const validation = (name, value) => {
    console.log(name, value, "value");
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const handleSubmit2 = async (event) => {
    setLoading(true);
    console.log(selectedImage, "selectedImage");
    if (selectedImage) {
      console.log(validation("imagename", selectedImage), "imageclg");
      if (validation("imagename", selectedImage)) {
        await uploadFile(selectedImage, "Imagename", event);
      } else {
        toastSuccess("image error, jpg|jpeg|png|gif|mp4");
        setLoading(false);
        return;
      }
    } else {
      console.log(event, "event");
      handleSubmit("", event);
    }
  };

  const handleSubmit = async (imageurl, eventObject) => {
    axios
      .post(
        `${config.brandBaseUrl}/brands/upsert`,
        {
          id: eventObject.ID,
          isactive: 1,
          name: eventObject.Name,
          loginuserid: loginUserId,
          Imagename: imageurl ? imageurl : eventObject.Imagename,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData();
          setLoading(false);
          window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
        setLoading(false);
      });
  };

  // Delete Brand
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      id: pID,
      loginuserid: loginUserId,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = {
      ID: 0,
      Name: "",
      Imagename: "",
      brandInfopopup: "",
    };
    setFormValues(clearData);
    setModal(true);
  };

  const handelShowPopup = (checked) => {
    console.log(checked, "checked");
    setValueAllChecked(checked);
    setShowDateFilterModal(true);
  };

    const handleBrandUpsert = (brandId, columnKey, isChecked) => {
    const payload = {
      BrandID: brandId,
      ColumnName: columnKey,
      Value: isChecked ? 1 : 0,
    };

    axios
      .post(`${config.brandBaseUrl}/brands/upsertBrandDynamic`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // Update data locally WITHOUT triggering API fetch again
          setData((prevData) =>
            prevData.map((item) =>
              item.ID == brandId
                ? {
                    ...item,
                    [columnKey]: isChecked ? 1 : 0, // make sure this matches the server's format
                  }
                : item
            )
          );
          toastSuccess('Brands Upsert SuccessFully')
        } else {
          toastError("Update failed");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

    
    const handleCategoryIsEcomUpsert = (CatID, from, isChecked) => {
      const payload = {
        CatID: CatID,
        ColumnName: from,
        Value: isChecked ? 1 : 0,
        // LoginUserId: loginUserId,
      };
  
      axios
        .post(
          `${config.brandBaseUrl}/brands/assignbrandecommercemenu`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            console.log("Updated successfully");
            setData((prevData) =>
              prevData.map((item) =>
                item.ID == CatID
                  ? {
                      ...item,
                      [from]: isChecked ? 1 : 0, // make sure this matches the server's format
                    }
                  : item
              )
            );
            toastSuccess("Categories Upsert SuccessFully");
          } else {
            // toastError("Update failed");
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    };
    
  const generateDynamicColumns = (configData) => {
    const parseBool = (val) => ["true", true, "1", 1].includes(val);
    const columns = [];

    // Add MainSite column if enabled
    const mainSiteEnabled = parseBool(
      configData.find((item) => item.AppConfigkey === "MainSiteEnable")
        ?.AppConfigvalue
    );

    if (mainSiteEnabled) {
      const mainSiteAlias =
        configData.find((item) => item.AppConfigkey === "MainSiteAlias")
          ?.AppConfigvalue || "Main Site";

      // columns.push({
      //   header: (
      //   <div>
      //     <input
      //     className="form-check-input mr-1"
      //     type="checkbox"
      //     onClick={() => {
      //       const allIds = data.map((item) => item.ID).join(",");
      //       const allChecked = data.every((item) => item.MainSite);
      //       handleBrandUpsert(allIds, "MainSite", !allChecked ? 1 : 0);
      //       setData((prevData) =>
      //       prevData.map((item) => ({...item, MainSite: !allChecked ? 1 : 0,}))
      //       );
      //     }}
      //     checked={data.length > 0 && data.every((item) => item.MainSite)}
      //     readOnly
      //     />
      //     <label>{mainSiteAlias}</label>
      //   </div>
      //   ),
      //   accessorKey: "MainSite",
      //   Cell: ({ row }) => (
      //   <input
      //     className="form-check-input"
      //     type="checkbox"
      //     role="switch"
      //     checked={!!row.original.MainSite}
      //     onChange={(e) => {
      //     handleBrandUpsert(row.original.ID, "MainSite", e.target.checked ? 1 : 0);
      //     setData((prevData) =>
      //       prevData.map((item) => item.ID === row.original.ID ? { ...item, MainSite: e.target.checked ? 1 : 0 }
      //         : item
      //       )
      //     );
      //     }}
      //   />
      //   ),
      // });
      columns.push({
        header: (
          <div>
            <input
              className="form-check-input mr-1"
              type="checkbox"
              onClick={() => {
                const allIds = data.map((item) => item.ID).join(",");
                const allChecked = data.every((item) => item.MainSite == 1);

                // Show confirmation before proceeding
                setConfirmAction({
                  allIds,
                  allChecked,
                  newValue: !allChecked ? 1 : 0,
                  columnKey: "MainSite", // Pass the correct
                });
              }}
              // readOnly
              checked={data.every((item) => item.MainSite == 1)}
            />
            <label>{mainSiteAlias}</label>
          </div>
        ),
        accessorKey: "MainSite",
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={!!row.original.MainSite}
            onChange={(e) => {
              handleBrandUpsert(
                row.original.ID,
                "MainSite",
                e.target.checked ? 1 : 0
              );
              setData((prevData) =>
                prevData.map((item) =>
                  item.ID === row.original.ID
                    ? { ...item, MainSite: e.target.checked ? 1 : 0 }
                    : item
                )
              );
            }}
          />
        ),
      });
    }

    // Dynamically add Multisite columns (1, 2, 3...)
    const aliasKeys = configData.filter((item) =>
      /^SiteAlias\d+$/.test(item.AppConfigkey)
    );

    for (let i = 1; i <= aliasKeys.length; i++) {
      const alias = configData.find(
        (el) => el.AppConfigkey === `SiteAlias${i}`
      )?.AppConfigvalue;
      const enabled = ["true", true, "1", 1].includes(
        configData.find((el) => el.AppConfigkey === `SiteEnable${i}`)
          ?.AppConfigvalue
      );

      if (enabled && alias) {
        const columnKey = `MultisiteEcommerce${i}`;
        columns.push({
          header: (
            <div>
              <input
          className="form-check-input mr-1"
          type="checkbox"
          onClick={() => {
            const allIds = data.map((item) => item.ID).join(",");
            const allChecked = data.every(
              (item) => item[columnKey] == 1
            );

            // Show confirmation before proceeding
            setConfirmAction({
              allIds,
              allChecked,
              newValue: !allChecked ? 1 : 0,
              columnKey, // Pass the correct columnKey
            });
          }}
          checked={data.every(
            (item) => item[columnKey] == 1
          )}
              />
              <label>{alias}</label>
            </div>
          ),
          accessorKey: columnKey,
          Cell: ({ row }) => (
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={!!row.original[columnKey]}
              onChange={(e) =>
          handleBrandUpsert(row.original.ID, columnKey, e.target.checked)
              }
            />
          ),
        });
      }
    }

    return columns;
  };

    const generateDynamicIsShowEcomMenuColumns = (
    configData,
    data,
    setData,
    setconfirmActionIsEcom,
    handleCategoryIsEcomUpsert,
    visibilityFlags // ✅ same flags
  ) => {
    const { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble } =
      visibilityFlags;
    const parseBool = (val) => ["true", true, "1", 1].includes(val);
    const columns = [];

    // MainSite
    const mainSiteEnabled = parseBool(
      configData.find((item) => item.AppConfigkey === "MainSiteEnable")
        ?.AppConfigvalue
    );

    if (mainSiteEnabled) {
      const mainSiteAlias =
        configData.find((item) => item.AppConfigkey === "MainSiteAlias")
          ?.AppConfigvalue || "Main Site";
      const columnKey = "IsShowEcommerceMenuMainSite";

      columns.push({
        header: (
          <div>
            <input
              className="form-check-input mr-1"
              type="checkbox"
              checked={data.every((item) => item[columnKey] == 1)}
              onClick={() => {
                const allIds = data.map((item) => item.ID).join(",");
                const allChecked = data.every((item) => item[columnKey] == 1);
                setconfirmActionIsEcom({
                  allIds,
                  allChecked,
                  newValue: allChecked ? 0 : 1,
                  columnKey,
                });
              }}
            />
            <label>{mainSiteAlias} Menu</label>
          </div>
        ),
        accessorKey: columnKey,
        enableSorting: false,
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={!!row.original[columnKey]}
            onChange={(e) => {
              const isChecked = e.target.checked;
              handleCategoryIsEcomUpsert(
                row.original.ID.toString(),
                columnKey,
                isChecked ? 1 : 0
              );
              setData((prevData) =>
                prevData.map((item) =>
                  item.ID === row.original.ID
                    ? { ...item, [columnKey]: isChecked ? 1 : 0 }
                    : item
                )
              );
            }}
          />
        ),
      });
    }

    // Multisite Menu columns
    for (let i = 1; i <= 3; i++) {
      const alias = configData.find(
        (el) => el.AppConfigkey === `SiteAlias${i}`
      )?.AppConfigvalue;
      const enabled = parseBool(
        configData.find((el) => el.AppConfigkey === `SiteEnable${i}`)
          ?.AppConfigvalue
      );
      const isVisible =
        (i === 1 && firstDynamicVisble) ||
        (i === 2 && secondDynamicVisble) ||
        (i === 3 && thirdDynamicVisble);

      if (enabled && alias && isVisible) {
        const columnKey = `IsShowEcommerceMenuMultisiteEcommerce${i}`;

        columns.push({
          header: (
            <div>
              <input
                className="form-check-input mr-1"
                type="checkbox"
                checked={data.every((item) => item[columnKey] == 1)}
                onClick={() => {
                  const allIds = data.map((item) => item.ID).join(",");
                  const allChecked = data.every((item) => item[columnKey] == 1);
                  setconfirmActionIsEcom({
                    allIds,
                    allChecked,
                    newValue: allChecked ? 0 : 1,
                    columnKey,
                  });
                }}
              />
              <label>{alias} Menu</label>
            </div>
          ),
          accessorKey: columnKey,
          enableSorting: false,
          Cell: ({ row }) => (
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={!!row.original[columnKey]}
              onChange={(e) => {
                const isChecked = e.target.checked;
                handleCategoryIsEcomUpsert(
                  row.original.ID.toString(),
                  columnKey,
                  isChecked ? 1 : 0
                );
                setData((prevData) =>
                  prevData.map((item) =>
                    item.ID === row.original.ID
                      ? { ...item, [columnKey]: isChecked ? 1 : 0 }
                      : item
                  )
                );
              }}
            />
          ),
        });
      }
    }

    return columns;
  };

  // const dynamicColumns = generateDynamicColumns(dynamicSiteRespose);

  // Non-dynamic static columns
  const staticColumns = [
    {
      header: "Brand",
      accessorKey: "Name",
    },
    {
      header: "Image",
      accessorKey: "Imagename",
      Cell: ({ row }) => (
        <>
          {row.original.Imagename !== "" &&
          row.original.Imagename !== "NO IMAGE" ? (
            <a target="_blank" href={row.original.Imagename}>
              <img
                src={row.original.Imagename}
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            </a>
          ) : (
            <img
              src={Noimage}
              style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
            />
          )}
        </>
      ),
    },
    {
      header: "Brand Count",
      accessorKey: "Count",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          }}
          onClick={() => {
            setRunApi(true);
            setModuleId(row.original.ID);
            setBrandName(row.original.Name);
          }}
        >
          {row.original.Count}
        </Box>
      ),
    },
    // {
    //   header: (
    //     <>
    //       <input
    //         className="form-check-input mr-1"
    //         onChange={(event) => handelShowPopup(event.target.checked)}
    //         type="checkbox"
    //         role="switch"
    //         checked={valueAllChecked === true}
    //       />{" "}
    //       <label> Show On Menu</label>
    //     </>
    //   ),
    //   left: true,
    //   accessorKey: "IsShowEcommerceMenu",
    //   Cell: ({ row }) => (
    //     <input
    //       className="form-check-input"
    //       onChange={(e) => handleSwitchOnOff(e, row)}
    //       type="checkbox"
    //       role="switch"
    //       checked={row.original.IsShowEcommerceMenu}
    //     />
    //   ),
    // },
  ];

    const dynamicColumnsSite = useMemo(
      () =>
        generateDynamicColumns(
          dynamicSiteRespose,
          data,
          setData,
          setConfirmAction,
          handleBrandUpsert,
          { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble }
        ),
      [
        dynamicSiteRespose,
        data,
        firstDynamicVisble,
        secondDynamicVisble,
        thirdDynamicVisble,
      ]
    );
  
    const dynamicIsShowEcomMenuCols = useMemo(
      () =>
        generateDynamicIsShowEcomMenuColumns(
          dynamicSiteRespose,
          data,
          setData,
          setconfirmActionIsEcom,
          handleCategoryIsEcomUpsert,
          { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble }
        ),
      [
        dynamicSiteRespose,
        data,
        firstDynamicVisble,
        secondDynamicVisble,
        thirdDynamicVisble,
      ]
    );
  

  // Final memoized columns list
  const columns = useMemo(() => {
    return [
      ...dynamicColumnsSite,
      ...staticColumns,
      ...dynamicIsShowEcomMenuCols,
    ];
  }, [
    firstDynamicVisble,
    secondDynamicVisble,
    thirdDynamicVisble,
    firstDynamicAlies,
    secondDynamicAlies,
    thirdDynamicAlies,
    valueAllChecked,
    data,
    dynamicColumnsSite,
    staticColumns,
    dynamicIsShowEcomMenuCols,
  ]);

  const [columnOrder, setColumnOrder] = useState([
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
    "mrt-row-actions",
  ]);

  const checkFunction = (checkedBrands) => {
    let brandsList = {
      brandsList: checkedBrands.join(","),
      LoginUserId: loginUserId,
    };

    axios
      .post(
        `${config.brandBaseUrl}/brands/assignbrandecommercemenu`,
        brandsList,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // toastSuccess(SUCCESS_MESSAGE)
          console.log("SetDone");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError(ERROR_EXISTS);
        } else {
          // toastError(ERROR_MESSAGE);
        }
      });
  };



  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleAllSwitchOnOff(valueAllChecked);
  };

  const handleAllSwitchOnOff = (checked) => {
    // const { checked } = e.target;
    console.log(checked, "checkedBy Allcategory");

    if (checked == true) {
      let finalArray = [];
      data.map((el) => finalArray.push(el?.ID));
      setCheckedBox(finalArray);

      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 1,
        };
      });
      setData(updatedData);
      checkFunction(finalArray);
    } else {
      setCheckedBox([]);
      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 0,
        };
      });
      setData(updatedData);
      checkFunction([]);
    }
  };

  const handleSwitchOnOff = (e, row) => {
    const { checked } = e.target;
    console.log(checked, row, "checkedBy Allcategory1");

    if (checked === true) {
      console.log(checked, row.original?.ID, "checkedBy Allcategory");
      const FilterData = [...checkedBox, row.original?.ID];
      setCheckedBox(FilterData);

      const updatedData = data.map((el) => {
        if (el.ID === row.original?.ID) {
          return {
            ...el,
            IsShowEcommerceMenu: 1,
          };
        } else {
          return el;
        }
      });
      setData(updatedData);
      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);

      checkFunction(FilterData);
    } else {
      const FilterData = checkedBox.filter((item) => item !== row.original?.ID);
      setCheckedBox(FilterData);

      const updatedData = data.map((el) => {
        if (el.ID === row.original?.ID) {
          return {
            ...el,
            IsShowEcommerceMenu: 0,
          };
        } else {
          return el;
        }
      });
      setData(updatedData);
      checkFunction(FilterData);

      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);
    }
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setValueAllChecked(!valueAllChecked);
  };

  const _handleFileChange = (e) => {
    console.log(e, "imageUpload");

    const file = e.target.files[0];
    setSelectedImage(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewImage(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const renderRowActions = ({ row }) => {
    const { original } = row;
    return (
      <div>
        {checkUserPermission(PERMISSION_EDIT) && (
          <Link
            className="btn btn-primary"
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#ManageDataModal"
            data-backdrop="static"
            data-keyboard="false"
            onClick={() => handleUpdate(row.original.ID)}
          >
            Edit
          </Link>
        )}
        {checkUserPermission(PERMISSION_DELETE) && (
          <Link
            className="btn btn-sm btn-secondary confirm-text ml-2"
            to="#"
            title="Delete"
            data-bs-toggle="modal"
            data-bs-target="#DeleteConfirmationModal"
            onClick={() => handleDeletePopup(row.original.ID)}
          >
            Delete
          </Link>
        )}
      </div>
    );
  };

  const handleGetData = () => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=EnableMultiSiteModule`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;
        setDynamicSiteRespose(responseData);
        console.log(responseData, "responseData=>786");

        const isFirstSiteEnabled = ["true", true, "1", 1].includes(
          responseData.find((el) => el.AppConfigkey === "FirstSiteEnable")
            ?.AppConfigvalue
        );

        const isFirstSiteAlies = responseData.find(
          (el) => el.AppConfigkey === "MainSiteAlias"
        )?.AppConfigvalue;
        const isSecondSiteAlies = responseData.find(
          (el) => el.AppConfigkey === "SiteAlias1"
        )?.AppConfigvalue;
        const isThirdSiteAlies = responseData.find(
          (el) => el.AppConfigkey === "SiteAlias2"
        )?.AppConfigvalue;

        const isFirstSiteVisible = responseData.find(
          (el) => el.AppConfigkey === "SiteEnable1"
        )?.AppConfigvalue;
        const isSecondSiteVisible = responseData.find(
          (el) => el.AppConfigkey === "SiteEnable2"
        )?.AppConfigvalue;
        const isThirdSiteVisible = responseData.find(
          (el) => el.AppConfigkey === "SiteEnable3"
        )?.AppConfigvalue;

        // Parse boolean properly
        setFirstDynamicVisible(
          ["true", "1", true, 1].includes(isFirstSiteVisible)
        );
        setSecondDynamicVisible(
          ["true", "1", true, 1].includes(isSecondSiteVisible)
        );
        setThirdDynamicVisible(
          ["true", "1", true, 1].includes(isThirdSiteVisible)
        );

        setFirstDynamicAlies(isFirstSiteAlies);
        setSecondDynamicAlies(isSecondSiteAlies);
        setThirdDynamicAlies(isThirdSiteAlies);

        // setFirstDynamicVisible(isFirstSiteVisible);
        // setSecondDynamicVisible(isSecondSiteVisible);
        // setThirdDynamicVisible(isThirdSiteVisbile);

        console.log(isFirstSiteAlies, "isFirstSiteAlies responseData=>786");
        setEnableFirstSite(isFirstSiteEnabled);

        console.log(isFirstSiteEnabled, "check if first site is enabled");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  // Brand Upsert by for dynamic site


  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      {confirmAction && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "40px",
              borderRadius: "5px",
              zIndex: 10000, 
            }}
          >
            <p className="text-center">
              Are you sure you want to{" "}
              {confirmAction.allChecked ? "uncheck" : "check"} all Brands?
            </p>
            <div className="d-flex align-items-center justify-content-center gap-2 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleBrandUpsert(
                    confirmAction.allIds,
                    confirmAction.columnKey,
                    confirmAction.newValue
                  );
                  setData((prevData) =>
                    prevData.map((item) => ({
                      ...item,
                      [confirmAction.columnKey]: confirmAction.newValue,
                    }))
                  );
                  setConfirmAction(null);
                }}
              >
                Yes
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setConfirmAction(null)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

         {confirmActionIsEcom && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "40px",
              borderRadius: "5px",
              zIndex: 10000,
            }}
          >
            <p className="text-center">
              Are you sure you want to{" "}
              {confirmActionIsEcom.allChecked ? "uncheck" : "check"} all
              Categories?
            </p>
            <div className="d-flex align-items-center justify-content-center gap-2 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleCategoryIsEcomUpsert(
                    confirmActionIsEcom.allIds,
                    confirmActionIsEcom.columnKey,
                    confirmActionIsEcom.newValue
                  );
                  setData((prevData) =>
                    prevData.map((item) => ({
                      ...item,
                      [confirmActionIsEcom.columnKey]:
                        confirmActionIsEcom.newValue,
                    }))
                  );
                  setconfirmActionIsEcom(null);
                }}
              >
                Yes
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setconfirmActionIsEcom(null)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Brand</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Brands</li>
              </ul>
            </div>
          </div>

          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              {rowSelectData?.length > 0 && (
                <button
                  className="btn btn-dark btn-sm mt-4"
                  onClick={() => handleDeletePopup(rowSelectData.join(","))}
                >
                  Delete Selected
                </button>
              )}
            </div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  onClick={() => handleManageDataPopup()}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  Add Brand
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  <CommonMatrialReactTable
                    columns={columns}
                    data={data}
                    hodiExport={false}
                    enableRowSelection={true}
                    enableRowActions={true}
                    renderRowActions={renderRowActions}
                    isRowSelectionManual={true}
                    setRowSelectData={setRowSelection}
                    setColumnOrder={setColumnOrder}
                    state={{
                      columnOrder,
                      rowSelection,
                    }}
                    columnsToExport={[
                      "ID",
                      "Name",
                      "Imagename",
                      "Count",
                      "CreatedDate",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Data list */}
        </div>
      </div>
      {/* Upset Model  */}
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Manage Brands</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit2}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="form-group">
                          <label className="col-form-label p-lg-medium">
                            Brand Name
                          </label>
                          <Field
                            type="text"
                            name="Name"
                            className={` ${
                              errors.Name ? "is-invalid" : ""
                            } form-control form-control-sm`}
                            placeholder="Enter Brand Name"
                            value={values.Name}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <div className="invalid-feedback">
                            {touched.Name && errors.Name ? errors.Name : ""}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="col-form-label p-lg-medium">
                            Brand Image
                          </label>
                          <div className="col-md-9">
                            {/* File input */}
                            <input
                              type="file"
                              name="Imagename"
                              className={`form-control form-control-sm`}
                              onBlur={handleBlur}
                              onChange={(e) => _handleFileChange(e)}
                            />
                            {/* Display a preview of the selected image */}
                            {values.Imagename && !previewImage && (
                              <img
                                src={values.Imagename}
                                alt="Brand Image"
                                style={{ maxWidth: "100px" }}
                              />
                            )}
                          </div>
                          {previewImage && (
                            <div className="row mb-3">
                              <div className="col-md-3"></div>
                              <div className="col-md-9">
                                <img
                                  src={previewImage}
                                  alt="Category Image Preview"
                                  className="ImagePreviewSize"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setPreviewImage("");
                          }}
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.brandBaseUrl}/brands/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Confirmation</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleDateFilterCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6 className="col-form-label p-lg-medium">
                    Do you want to set at All ?
                  </h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <InventorySubModulesRecordsModal
        Module="Brand"
        runApi={runApi}
        closepopup={() => {
          setRunApi(false);
          setModuleId(0);
          handleListData();
        }}
        ModuleId={moduleID}
        Name={brandName}
        columnsToExport={[
          "ID",
          "Item",
          "Name",
          "ImageName",
          "CreatedDate",
          "ItemId",
          "ItemVariationId",
          "BrandID",
          "Brand",
        ]}
      />
    </>
  );
};

export default Brand;

